import React from "react";
import styled from "styled-components";

const Dropdown = () => {
  return (<div>
    <Stli>마이페이지</Stli>
    <Stli>로그인</Stli>
  </div>)
}
export default Dropdown;

const Stli = styled.li`
  list-style:none;
`